import request from '@/utils/request'

// 查询列表
export function apiJobClassList (query) {
  return request({
    url: '/mes/jobClass/list',
    method: 'get',
    params: query
  })
}

// 新增
export function apiJobClassAdd (data) {
  return request({
    url: '/mes/jobClass',
    method: 'post',
    data: data
  })
}

// 修改
export function apiJobClassUpdate (data) {
  return request({
    url: '/mes/jobClass',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiJobClassNewExport (data) {
  return request({
    url: '/mes/jobClass/v2/export',
    method: 'post',
    data: data
  })
}

// 工单类型分类下拉列表
export function apiJobClassPullDownList (query) {
  return request({
    url: '/mes/jobClass/pullDownList',
    method: 'get',
    params: query
  })
}
